import { Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const ViewMoreCasesButton = (props) => {
  const { t } = useTranslation();
  return (
    <Link to={props.whereTo}>
      <Button colorScheme="blackAlpha" sx={{ w: "100%", mt: "10px" }}>
        {t("View more")}
      </Button>
    </Link>
  );
};
